import Card from "common/Boxes/Card.tsx";
import React, { ReactNode, useContext } from "react";
import useMedia from "utils/hooks/useMedia.ts";
import styled from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import Flex from "common/Boxes/Flex.tsx";
import { DrawerContext } from "common/Drawers/Drawer.context.ts";
import { phoneMaxWidth } from "common/NewLook/layout.ts";

interface TwoChartsTopContainerProps {
  largeChartUpperMiddle: ReactNode;
  smallChartUpperLeft: ReactNode;
  extraActions?: ReactNode;
}

const TwoChartsTopContainer = ({
  largeChartUpperMiddle,
  smallChartUpperLeft,
  extraActions,
}: TwoChartsTopContainerProps) => {
  const isSmallScreen = useMedia([`(max-width: 750px)`], [true], false);
  const { isDrawer } = useContext(DrawerContext) || {};
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  if (isBottomNavigator || isSmallScreen || isDrawer) {
    return (
      <ChartActionsWrapper $isDrawer={isDrawer}>
        {isBottomNavigator || isDrawer
          ? smallChartUpperLeft
          : largeChartUpperMiddle}
        {!!extraActions && <ActionsWrapper>{extraActions}</ActionsWrapper>}
      </ChartActionsWrapper>
    );
  }

  return (
    <ChartsWrapper>
      <Card>{smallChartUpperLeft}</Card>
      <LargeChartCard>{largeChartUpperMiddle}</LargeChartCard>
    </ChartsWrapper>
  );
};

export default TwoChartsTopContainer;

const ChartsWrapper = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-rows: 400px auto;
  column-gap: 16px;
  margin-bottom: 8px;
`;
const ChartActionsWrapper = styled.div<{ $isDrawer?: boolean }>`
  margin-bottom: 8px;
  height: 330px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${phoneMaxWidth}) {
    height: auto;
    margin-bottom: 0;
  }
  ${(p) => p.$isDrawer && `height: 100%`};
`;
const LargeChartCard = styled(Card)`
  height: 400px;
  display: flex;
  flex-direction: column;
`;
const ActionsWrapper = styled(Flex)`
  justify-content: flex-end;
  margin: 12px 0;
  column-gap: 8px;
`;
